var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-footer"},[_vm._v(" ©copyright 华侨大学建筑学院虚拟仿真实验申报管理平台 ")])}
var staticRenderFns = []

export { render, staticRenderFns }